import { Mail01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Mail = /* @__PURE__ */ createIcon(Mail01Icon, 'Mail');
